import React from 'react';

import RecommendationSlideContent from './RecommendationSlideContent';
import RecommendationSlideWithEnergyClass from './RecommendationSlideWithEnergyClass';
import type { RecommendationsSlideProps } from './types';

const RecommendationSlide = (props: RecommendationsSlideProps) =>
  props.energyClass ? (
    <RecommendationSlideWithEnergyClass {...props} />
  ) : (
    <RecommendationSlideContent {...props} />
  );

export default RecommendationSlide;
